<div style="width: 100vw; height: 100vh; background-color: #fff" appLoading [loading]="true"></div>
